import React, { useState } from 'react';
import Lock from '../../components/organism/Lock';
import LockModal from '../../components/organism/Lock/modalLock';
import { hasPermission } from '../../stores/accessControlStore';

interface iProtectedComponent {
  modulesAllowed: string[];
  allowModal: boolean;
  children: React.ReactNode;
}

export function ModuleGuard({
  modulesAllowed,
  allowModal,
  children,
}: iProtectedComponent) {
  const [isOpen, setIsOpen] = useState(allowModal);

  function onClose() {
    setIsOpen(!isOpen);
  }

  if (hasPermission(modulesAllowed)) {
    return <>{children}</>;
  }

  if (allowModal) {
    return <LockModal isOpen={isOpen} onClose={onClose} />;
  }

  return <Lock />;
}
